import { $Types } from '@Ravnur-Inc/core/typings/tsx';
import { Prop } from '@Ravnur-Inc/decorators';
import { renderSlot } from 'vue';
import { Vue } from 'vue-class-component';

import { Media } from '@/types/Media';

import './media-grid-snippet.scss';

const CN = 'media-grid-snippet';

class Props {
  media: Media;
}

export default class MediaGridSnippet extends Vue {
  declare $props: $Types<Props> & Partial<HTMLDivElement>;
  @Prop({}) public media!: Media;

  render() {
    const { media, $attrs, $slots } = this;
    const { title } = media;
    return (
      <div class={CN} title={title} {...$attrs}>
        <thumbnail class={`${CN}__thumbnail`} entity={media}>
          {renderSlot($slots, 'thumbnail')}
        </thumbnail>
        <span class={`${CN}__title`}>{title}</span>
      </div>
    );
  }
}
